import { useContext, useEffect, useState } from 'react';
import '../styles/stylesheets/home/Dashboard.scss'
import LanguageTranslator from '../locals/LanguageTranslator';
import { UserDetailsContext } from '../App';
import GenericCustomButton from '../genericComponents/GenericCustomButton';
import Icons from '../assets/icons';
import { MousePointerClick } from 'lucide-react';
import { parseJwt } from '../helper/genericFunction';
import { openDB } from 'idb';
import { getDataStorageKey } from '../helper/helperTableFunctions';
import { use } from 'react';
import GenericSpinnerLoader from '../loaders/GenericSpinnerLoader';

const HomeDashboard = () => {
  // const [dashboardModules, setDashboardModules] = useState([]);
  // const [hour, setHour] = useState(undefined);
  const {userDetails} = useContext(UserDetailsContext)
  const mainMenuModules = JSON.parse(userDetails?.mainMenu || "[]")
  const [currentActiveModule, setCurrentActiveModule] = useState(mainMenuModules?.activeModule);
  const [lastActiveModuleStates, setLastActiveModuleStates] = useState(null)
  const [loading, setLoading] = useState(false)

  // const mainModules = ['DIGIARS', 'DIGIPROC', 'DIGISALES', 'CDIGISALES', 'DIGIVEND'];


  const getOfflineStorageKey = () => {
    const uId = parseJwt(sessionStorage?.getItem?.('token'))?.jti;
    return `mainMenuLocalState+${uId}`
  }
  
  const getDb = async () => {
    setLoading(true)
    const db = await openDB(getDataStorageKey?.(), 1, {
      upgrade(db) {
        db.createObjectStore("LOCAL_CONFIG");
      }
    });
    return db;
  }

  const getActiveModuleState = async () => {
    setLoading(true)
    const db = await getDb?.();
		const dbData = await db.get("LOCAL_CONFIG", getOfflineStorageKey?.())
    setLastActiveModuleStates(dbData?.lastActiveModuleStates || {});
		db?.close?.()
    setLoading(false)
  }

  useEffect(() => {
    getActiveModuleState();
  }, []);

  const getDetails = () => {
    const activeModule = ['MDM', 'ADMIN'].includes(currentActiveModule) ? lastActiveModuleStates?.activeModule : currentActiveModule;

    console.log('activeModulee', activeModule)

    switch (activeModule) {
      case "DIGIARS": 
        return {
          logo : <Icons.AllokatorWithLabelFull height={55} className='max-w-[250px]'/>,
          image: <Icons.DigiArsImage className='max-w-[567px] w-full'/>,
          title: 'Smart Inventory Planning',
          subText: 'Optimize resources with Allokator!',
          description: 'Allocate smarter, cut down waste, and stay in control of your operations effortlessly.',
          link: 'https://www.supplymint.com/products/allokator',
          titleGradient: 'linear-gradient(103.45deg, #03A771 -0.81%, #3083B0 67.8%, #5D5FEF 100.4%) text'
        }
      
      case "DIGIPROC": 
        return {
          logo : <Icons.DigiProcWithLabelFull height={55} className='max-w-[250px]'/>,
          image: <Icons.DigiProcImage className='max-w-[567px] w-full'/>,
          title: 'Simplify your Purchase Cycle',
          subText: 'Centralized tracking for maximum efficiency',
          description: 'digiproc helps retail and D2C brands manage every step of buying, from vendor selection to PO tracking and invoice matching',
          link: 'https://www.supplymint.com/products/digiproc',
          titleGradient: 'linear-gradient(90.4deg, #5D5FEF 0.12%, #FF8800 99.86%) text'
        }
      
      case "DIGISALES":
      case "CDIGISALES":
        return {
          logo : <Icons.DigiSalesWithLabelFull height={55} className='max-w-[250px]'/>,
          image: <Icons.DigiSalesImage className='max-w-[567px] w-full'/>,
          title: <><LanguageTranslator>Simplify B2B Sales</LanguageTranslator> <LanguageTranslator tag='span' className='whitespace-nowrap'>Order Management</LanguageTranslator></>,
          subText: 'Built for Speed & Accuracy',
          description: 'Streamline wholesale sales from catalog to delivery with Sales by digisales. Fast, accurate, and visible.',
          link: 'https://www.supplymint.com/products/digisales',
          titleGradient: 'linear-gradient(98.7deg, #FFAB09 12.59%, #03A771 96.89%) text, linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) text'
        }

      case "DIGIVEND": 
        return {
          logo : <Icons.DigiVendWithLabelFull height={55} className='max-w-[250px]'/>,
          image: <Icons.DigiVendImage className='max-w-[567px] w-full'/>,
          title: 'Simplify B2B Vendor Collaboration',
          subText: 'Designed to streamline purchase order and vendor collaboration workflows',
          description: 'Streamline wholesale sales from catalog to delivery with Sales by Supplymint. Fast, accurate, and visible.',
          link: 'https://www.supplymint.com/',
          titleGradient: 'linear-gradient(103.45deg, #008AF2 44.44%, #007AFF 100.4%) text'
        }
      
        
    
      default:
        break;
    }
  }

  return (
    <div className='p-[12px] pl-[28px] min-h-[calc(100vh-88px)] flex flex-col'>
      <div className={`p-[10px] bg-white h-full w-full flex flex-col ${currentActiveModule ? 'min-h-[calc(100vh-112px)]' : 'h-[calc(100vh-70px)] pb-[6rem]'}`}>
        <div 
          className={`py-6 px-6 2xl:py-[5vh] 2xl:px-[5vh] rounded-[10px] h-full w-full flex flex-col text-[#111D31] min-h-[calc(100vh-112px)]`}
          style={{
            background: 'linear-gradient(180deg, #E9E9E9 0%, #FFFFFF 100%)'
          }}
        >
          <div className={`flex flex-col items-center ${currentActiveModule ? 'mb-6 2xl:mb-16' : 'mb-2 2xl:mb-10'}`}>
            <div className='px-3 h-[26px] flex items-center justify-center mb-1.5 w-fit rounded-full border border-[#BBBDBF]'>
              <p className='mb-0 text-xs'>Hello, Let’s get Started</p>
            </div>
            <div className='flex items-center gap-3'>
              <img className='w-[36px] h-[36px] mb-[2px]' src={require('.././assets/images/waving-hand.png')} alt='' />
              <h2 className='text-[46px]'>Welcome to Supplymint</h2>
            </div>
            <p className='mb-2 text-sm'>{currentActiveModule ? 'Industry Leading Suite presents' : 'Modern Industry Leading Suite'}</p>
            
            {/* divider */}
            <div
              style={{
                background: 'linear-gradient(90deg, rgba(187, 189, 191, 0.1) 0%, #898B8C 50%, rgba(187, 189, 191, 0.1) 100%)'
              }}
              className='w-[300px] h-[1px]'
            ></div>
          </div>


          {loading ? <div className='h-full w-full flex items-center justify-center'><GenericSpinnerLoader/></div> : <div className={`flex items-center justify-center h-full max-h-[1000px] gap-[50px] 2xl:gap-[7vw] ${currentActiveModule ? 'flex-col lg:flex-row' : 'text-center'}`}>
            {
              currentActiveModule ?
              <>
                <div className='w-full text-center flex items-center justify-center lg:justify-end'>
                  <div className='flex flex-col w-fit items-center justify-center'>

                    {/* logo */}
                    <div className='px-6 py-3.5 mb-6 w-fit h-[92px] flex items-center justify-center bg-white rounded-[20px] ring-2 ring-white ring-opacity-50'>
                      {getDetails()?.logo}
                    </div>
                    <h3
                      style={{
                        background: getDetails()?.titleGradient,
                        // background: 'linear-gradient(103.45deg, #008AF2 44.44%, #007AFF 100.4%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        color: 'transparent'
                      }}
                      className='mb-5 text-[60px] font-semibold leading-[125%] max-w-[700px]'
                    >{getDetails()?.title}</h3>
                    <p className='mb-1.5 text-[26px] font-medium text-fontBlack max-w-[700px]'>{getDetails()?.subText}</p>
                    <p className='mb-7 text-sm font-medium text-[#6A6C70] max-w-[700px]'>{getDetails()?.description}</p>
                    <GenericCustomButton
                      type='outline'
                      size='large'
                      className='min-w-[183px]'
                      leftIcon={<MousePointerClick size={18} />}
                      label={'Learn More'}
                      onClick={() => window.open(getDetails()?.link || 'https://www.supplymint.com/', '_blank')}
                    />
                  </div>
                </div>
                <div className='w-full flex justify-start lg:justify-start items-center'>
                  <div className='w-fit'>
                      {/* <img className='h-auto w-[567px] 2xl:w-[90%] 2xl:max-w-[700px] object-contain object-center' src={require('.././assets/images/digiProcDashImage.png')} alt='' /> */}
                      {getDetails()?.image}
                  </div>
                </div>
              </>
              : <>
                  <div className='py-7 px-11 bg-white relative border-2 border-[#6A6C7033] rounded-[40px] rounded-br-none w-[50%] max-w-[582px]'>
                    <p 
                      style={{
                          background: 'linear-gradient(103.45deg, #5D5FEF 44.44%, #007AFF 100.4%)',
                          // background: 'linear-gradient(103.45deg, #008AF2 44.44%, #007AFF 100.4%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                          color: 'transparent'
                        }}
                      className='mb-1 text-[30px] 2xl:text-[40px] font-semibold text-[#6A6C70]'
                    >Dear User</p>
                    <div className='mb-3.5 flex items-center justify-center gap-2'>
                      <p className='mb-0 text-[15px] 2xl:text-[20px] font-medium'>No modules have been issued to your account yet.</p>
                    </div>
                    {/* gradient line */}
                    <div
                      style={{
                        background: 'linear-gradient(90deg, rgba(187, 189, 191, 0.1) 0%, #898B8C 50%, rgba(187, 189, 191, 0.1) 100%)'
                      }}
                      className='mb-4 shrink-0 h-[1px] w-[220px] mx-auto'
                    ></div>
                    <div className='mb-8 relative'>
                      <Icons.DoubleQuote className='absolute top-[4px] left-[-8px] shrink-0 opacity-50 -translate-y-1.5'/>
                      <p className='text-[11px] 2xl:text-base'>Once your administrator assigns you access to specific modules, you’ll be able to view and manage your supply chain activities here. In the meantime, feel free to explore more about our solutions at website.</p>
                      <Icons.DoubleQuote className='absolute bottom-[-2px] right-[0px] shrink-0 opacity-50' style={{transform: 'rotate(180deg)'}}/>
                    </div>
                    <GenericCustomButton
                      type='outline'
                      size='large'
                      className='min-w-[183px] mx-auto'
                      leftIcon={<MousePointerClick size={18} />}
                      label={'Learn More'}
                      onClick={() => window.open('https://www.supplymint.com/', '_blank')}
                    />

                    {/* triangle */}
                    <div class="absolute top-full right-[-1px]">
                      <div className='top-0 right-0 w-0 h-0 
                      border-l-[54px] border-l-transparent 
                      border-t-[54px] border-t-[#6A6C7033]'>
                        <div className='absolute top-0 right-[1px] w-0 h-0 
                        border-l-[50px] border-l-transparent   
                        border-t-[50px] border-t-white'></div>
                      </div>
                  </div>

                  {/* message icon */}
                  {/* <div className='absolute z-[1] top-[-28px] right-[-16px]'>
                    <Icons.EmailInBlueBox/>
                  </div> */}


                  </div>
                  <div>
                    <Icons.HomeDashNoModuleImage className='w-full h-auto object-contain'/>  
                  </div>
              </>
            }
          </div>}

        </div>
      </div>
    </div>
  )
};

export default HomeDashboard;
